import React, { useEffect, useState, useRef } from "react";
import { styled } from "@mui/material/styles";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const Label = styled(FormControlLabel)({
  [`& .MuiFormControlLabel-label`]: {
    fontFamily: "Helvetica",
    fontSize: "0.8rem",
    fontWeight: 400,
    lineHeight: "1rem",
  },
});

export default function DaysCheckboxGroup({ label = "", value = "", onChange, disabled = "" }) {
  const [state, setState] = useState({
    sun: false,
    mon: false,
    tues: false,
    wed: false,
    thurs: false,
    fri: false,
    sat: false,
  });
  const [skipUpdateOnInitialRender, setSkipUpdateOnInitialRender] = useState(true);

  const prevValueRef = useRef();

  useEffect(() => {
    if (value !== prevValueRef.current) {
      const dow = value.split("");
      const dowNum = dow.map(Number);
      setState({
        sun: Boolean(dowNum[0]),
        mon: Boolean(dowNum[1]),
        tues: Boolean(dowNum[2]),
        wed: Boolean(dowNum[3]),
        thurs: Boolean(dowNum[4]),
        fri: Boolean(dowNum[5]),
        sat: Boolean(dowNum[6]),
      });
      prevValueRef.current = value;
    }
  }, [value]);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    if (skipUpdateOnInitialRender) {
      setSkipUpdateOnInitialRender(false);
      return;
    }

    let result = "";
    result += state.sun ? "1" : "0";
    result += state.mon ? "1" : "0";
    result += state.tues ? "1" : "0";
    result += state.wed ? "1" : "0";
    result += state.thurs ? "1" : "0";
    result += state.fri ? "1" : "0";
    result += state.sat ? "1" : "0";

    if (onChange) onChange((prev) => ({ ...prev, daysOfWeek: result }));
  }, [state]);

  const { mon, tues, wed, thurs, fri, sat, sun } = state;

  const options = [
    { name: "sun", label: "Su", checked: sun },
    { name: "mon", label: "M", checked: mon },
    { name: "tues", label: "T", checked: tues },
    { name: "wed", label: "W", checked: wed },
    { name: "thurs", label: "Th", checked: thurs },
    { name: "fri", label: "F", checked: fri },
    { name: "sat", label: "Sa", checked: sat },
  ];

  return (
    <div>
      <FormControl component="fieldset">
        <FormLabel
          component="legend"
          sx={{
            fontSize: "0.9rem",
            "&.Mui-focused": {
              color: "#000",
            },
          }}
        >
          {label || "Filter days of the week"}
        </FormLabel>
        <FormGroup row sx={{}}>
          {options.map((day, index) => (
            <Label
              key={day.name}
              disabled={(disabled && disabled[index] === "1") || false}
              control={<Checkbox checked={day.checked} onChange={handleChange} name={day.name} />}
              label={day.label}
              labelPlacement="top"
              sx={{
                display: "flex",
                margin: 0,
              }}
            />
          ))}
        </FormGroup>
      </FormControl>
    </div>
  );
}
